import { useEffect, useRef, useState } from 'react'

// Cursor custom cu urmărire lină. IMPORTANT: bucla rAF se OPREȘTE când cursorul
// a prins mouse-ul (idle) și repornește la mișcare — altfel un rAF perpetuu ar
// ține pagina „ocupată" la nesfârșit (blochează screenshot-uri / consumă CPU).
export default function CustomCursor() {
  const dot = useRef(null)
  const [hovering, setHovering] = useState(false)
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    setEnabled(true)
    // ascunde cursorul real DOAR acum (CSS scopează `cursor:none` pe această clasă)
    document.body.classList.add('custom-cursor-active')

    let raf = 0
    let running = false
    let tx = -100, ty = -100, cx = -100, cy = -100

    const tick = () => {
      cx += (tx - cx) * 0.2
      cy += (ty - cy) * 0.2
      if (dot.current) dot.current.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`
      // s-a oprit? (a prins mouse-ul) → nu mai cerem cadre noi
      if (Math.abs(tx - cx) < 0.1 && Math.abs(ty - cy) < 0.1) {
        running = false
        return
      }
      raf = requestAnimationFrame(tick)
    }
    const start = () => {
      if (!running) {
        running = true
        raf = requestAnimationFrame(tick)
      }
    }
    const move = (e) => {
      tx = e.clientX
      ty = e.clientY
      setHovering(!!e.target.closest('a, button, [data-cursor]'))
      start()
    }

    window.addEventListener('mousemove', move)
    return () => {
      window.removeEventListener('mousemove', move)
      cancelAnimationFrame(raf)
      document.body.classList.remove('custom-cursor-active')
    }
  }, [])

  if (!enabled) return null

  return (
    <div
      ref={dot}
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[100] rounded-full bg-cream mix-blend-difference transition-[width,height] duration-300 ease-out"
      style={{ width: hovering ? 56 : 14, height: hovering ? 56 : 14 }}
    />
  )
}
